import { render, staticRenderFns } from "./SafetyAccidentReview.vue?vue&type=template&id=dbfb3a86&scoped=true&"
import script from "./SafetyAccidentReview.vue?vue&type=script&lang=js&"
export * from "./SafetyAccidentReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbfb3a86",
  null
  
)

export default component.exports